import { render, staticRenderFns } from "./DetailCompanyComponent.vue?vue&type=template&id=84d7fc0c&scoped=true"
import script from "./DetailCompanyComponent.vue?vue&type=script&lang=js"
export * from "./DetailCompanyComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailCompanyComponent.vue?vue&type=style&index=0&id=84d7fc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d7fc0c",
  null
  
)

export default component.exports